'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { SignIn } from '@clerk/nextjs';
import { useLocale, useTranslations } from 'next-intl';
import { isLocalAuth } from '@/lib/authMode';
import { LocalSignIn } from '@/components/auth/LocalSignIn';

// Login via Clerk. routing="hash" evita problemi con il prefisso locale (i sotto-step
// dell'auth stanno nell'hash, non nel path). Dopo il login va al redirect richiesto.
// signUpUrl mantiene il prefisso locale corrente per non perdere la lingua scelta.
function ClerkSignIn() {
  const locale = useLocale();
  const searchParams = useSearchParams();
  const raw = searchParams.get('redirect') || '/app/dashboard';
  const redirectTo = raw.startsWith('/') ? raw : '/app/dashboard';
  const prefix = locale === 'en' ? '' : `/${locale}`;
  return (
    <SignIn
      routing="hash"
      signUpUrl={`${prefix}/signup?redirect=${encodeURIComponent(redirectTo)}`}
      fallbackRedirectUrl={redirectTo}
      forceRedirectUrl={redirectTo}
    />
  );
}

export default function LoginPage() {
  const t = useTranslations('Auth.login');
  return (
    <div className="min-h-screen flex">
      <div className="hidden md:flex md:w-[480px] lg:w-[520px] shrink-0 bg-stone-950 dark:bg-zinc-800 relative overflow-hidden flex-col items-center justify-center p-12">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: 'url(/marble-dark.svg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.5,
            maskImage: 'radial-gradient(ellipse at 30% 50%, black 0%, transparent 70%)',
            WebkitMaskImage: 'radial-gradient(ellipse at 30% 50%, black 0%, transparent 70%)',
          }}
        />
        <div className="relative flex flex-col items-center text-center gap-8">
          <div className="flex items-center gap-3">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/logo-white.webp" alt="" width={26} height={26} style={{ width: 26, height: 26, objectFit: 'contain' }} />
            <span className="font-semibold text-lg tracking-tight text-stone-50">Lithosbase</span>
          </div>
          <div>
            <p className="text-[11px] font-mono tracking-[0.14em] uppercase mb-4" style={{ color: '#C9B585' }}>
              Stone warehouse management
            </p>
            <h2 className="text-2xl font-bold tracking-tight text-stone-50 max-w-[240px] leading-snug">
              {t('title')}
            </h2>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center bg-stone-50 dark:bg-zinc-950 p-6 md:p-12">
        {/* Stessa pagina, due moduli: quello di Clerk sui nostri server,
            il nostro sull'installazione del cliente. */}
        <Suspense>{isLocalAuth() ? <LocalSignIn /> : <ClerkSignIn />}</Suspense>
      </div>
    </div>
  );
}
